<template>
    <div>
        <a title="View" class="btn btn-sm akkurate-warning text-white" v-b-modal="String(data.id)">
            <span class="akkurate-small"> <font-awesome-icon :icon="['fas', 'eye']" /></span> 
        </a>
       <b-modal
        :id="String(data.id)"
        ref="modal"
        size="xl"
        @show="ModalOpened">
        <template #modal-title>
                <p class="m-0 fw-bold text-green">Branch View</p>
        </template>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <beat-loader-component
                        v-if="isLoading"
                        :isLoading="isLoading"
                    ></beat-loader-component>
                </div>
                <div class="col-12 col-md-6 mb-3">
                    <label class="akkurate-dark" for="name">Name</label>
                        <b-form-group
                        id="name"
                        label-for="name">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="data.name"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 mb-3">
                    <label class="akkurate-dark" for="mobile">Mobile Number</label>
                        <b-form-group
                        id="mobile"
                        label-for="mobile">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="data.mobile"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                
                <div class="col-12 col-md-6 mb-3">
                    <label class="akkurate-dark" for="address">Address</label>
                        <b-form-group
                        id="address"
                        label-for="address">
                        <b-form-textarea
                        class="mt-2 fields"
                        id="address"
                        v-model="data.address"
                        disabled
                        placeholder="Enter Address..."
                        ></b-form-textarea>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-6 mb-3">
                    <label class="akkurate-dark" for="region">Region</label>
                        <b-form-group
                        id="region"
                        label-for="region">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="getRegion"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 mb-3">
                    <label class="akkurate-dark" for="manager">Manager</label>
                        <b-form-group
                        id="manager"
                        label-for="manager">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="getManager"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                
                <!-- <div class="col-12 col-md-6">
                    <label class="akkurate-dark" for="recorded_date">Journal Code</label>
                        <b-form-group
                        id="recorded_date"
                        label-for="recorded_date">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="data.code"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark" for="recorded_date">Amount Requested</label>
                        <b-form-group
                        id="recorded_date"
                        label-for="recorded_date">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="data.amount_requested"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark" for="recorded_date">Amount Approved</label>
                        <b-form-group
                        id="recorded_date"
                        label-for="recorded_date">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="data.amount_approved"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark" for="recorded_date">Status</label>
                        <b-form-group
                        id="recorded_date"
                        label-for="recorded_date">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="data.status"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <label class="akkurate-dark" for="recorded_date">Narration</label>
                        <b-form-group
                        id="recorded_date"
                        label-for="recorded_date">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="data.narration"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-4">
                    <label class="akkurate-dark" for="branch">Branch</label>
                        <b-form-group
                        id="branch"
                        label-for="branch">
                        <b-form-input
                        class="mb-3 mt-2 field-container fields"
                        type="text"
                        v-model="data.branch.name"
                        disabled
                        ></b-form-input>
                    </b-form-group>
                </div>
                    -->
        </div>
        <!-- <div class="row">
            <div>
                <b-table :fields="fields" striped hover :items="items">
                </b-table>
            </div>
        </div> -->
        </div>
        
          <template #modal-footer="{ ok }">
               <div class="w-100">
               <!-- begin loader -->
               <!-- <beat-loader-component 
               class="float-left"
               v-if="isLoading"
               :isLoading="isLoading"
               ></beat-loader-component> -->
               <!-- end loader -->
               <!-- Emulate built in modal footer ok and cancel button actions -->
               <b-button @click="$bvModal.hide(String(data.id))" type="button" class="akkurate-grey-btn btn-size float-right border-0">Close</b-button>
               <!-- <b-button @click="ok()" type="submit" class="akkurate-green-btn btn-size me-2 float-right border-0">Add</b-button>      -->
               </div>
           </template>
           
       </b-modal>
    </div>
</template>
<script>
import ApiService from "@/core/services/api.service";
import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";
export default {
    name: "BranchView",
    props: ['data'],
    components: {
        BeatLoaderComponent,
    },
    data() {
        return {
            form: {
                branch: []
            },
            isLoading: false,
            fields: [
                { key: 'id', label: '#' },
                { key: 'amount_requested', label: 'Amt Req' },
                { key: 'amount_approved', label: 'Amt App' },
                { key: 'dr_amount', label: 'Debit Amt' },
                { key: 'cr_amount', label: 'Credit Amt' },
                { key: 'dr_amount_approved', label: 'Debit Amt App' },
                { key: 'cr_amount_approved', label: 'Credit Amt App' },
                { key: 'coa_sub_head', label: 'COA Subhead' },

            ],
            items: [],
        }
    },
    computed: {
        getRegion() {
            return this.data.regionfk?.name
        },
        getManager() {
            let first_name = this.data.managerfk?.first_name != undefined ? this.data.managerfk?.first_name : "";
            let surname = this.data.managerfk?.surname != undefined ? this.data.managerfk?.surname : "";
            return first_name + " " + surname;
        }
    },
    methods: {
        async getBranchDetails() {
            // this.isLoading = true;
            await ApiService.get(`/settings/branches/details/${this.id}`)
                .then((response) => {
                    this.data = response.data?.branch;
                    // console.log(response.data.branch);
                    // this.form.name = response.data?.branch?.name;
                    // this.form.address = response.data?.branch?.address;
                    // this.form.region = response.data?.branch?.regionfk;
                    // this.form.manager = response.data?.branch?.managerfk;
                    // this.form.mobile = response.data?.branch?.mobile;
                    // this.form.active = response.data?.branch?.status;
                    this.isLoading = false;
                }).catch((error) => {
                    this.isLoading = false;
                })
        },
        ModalOpened() {
            this.getBranchDetails();
        },
    }
}
</script>